// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"48":"d929c01e","295":"a172e73e","402":"c58ad016","447":"b6ec1a0c","574":"87c511f5","640":"0e8b7a9c","702":"c7393d42","860":"1c35ddd2","999":"6634015d"}[chunkId] + ".js";
};